import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import useStyles from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CeroItemPair from "../../../../../components/CeroItemPair";
import CeroInfoPair from "../../../../../components/CeroInfoPair";

const SupplierScreening = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { emissionData } = props;

  return (
    <>
      <div
        className={classes.backContainer}
        onClick={() => {
          navigate(-1);
        }}
      >
        <ArrowBackIosIcon />
        Back
      </div>
      <Container className={classes.container}>
        <Box className={classes.innerContainer}>
          <Box className={classes.header}>
            <Typography variant="h6" component="div">
              Supplier Screening using Environmental and Social Criteria
            </Typography>
          </Box>
          <Box className={classes.topContainer}>
            <Grid
              container
              direction={"row"}
              wrap="nowrap"
              justifyContent={"space-between"}
              display={"contents"}
              spacing={12}
            >
              <Grid
                item
                container
                direction={"column"}
                display={"contents"}
                xs={10}
              >
                <Box className={classes.actionBox}>
                  <CeroInfoPair
                    title="Status:"
                    value={emissionData.status ? emissionData.status : "NA"}
                    classes={{
                      container: classes.statusContainer,
                      title: classes.statusTitle,
                      value:
                        emissionData.status === "In Progress"
                          ? classes.Inprogress
                          : classes[emissionData?.status],
                    }}
                  />
                </Box>
                <CeroItemPair
                  title="Facility:"
                  value={
                    emissionData.facility_name
                      ? emissionData.facility_name
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Period:"
                  value={
                    emissionData.assessment_period
                      ? emissionData.assessment_period
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Year:"
                  value={emissionData.year ? emissionData.year : "NA"}
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Number of suppliers screened using Environmental Criteria:"
                  value={
                    emissionData.suppliers_screened_using_env_criteria
                      ? emissionData.suppliers_screened_using_env_criteria
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Environmental Criteria:"
                  value={
                    emissionData.environment_criteria_list
                      ? emissionData.environment_criteria_list?.map(
                          (criteria, index) => (
                            <li className={classes.list} key={index}>
                              {index + 1}. {criteria}
                            </li>
                          )
                        )
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                {emissionData.environment_criteria &&
                  emissionData.environment_criteria.includes("Others") && (
                    <CeroItemPair
                      title="Environmental Criteria Details:"
                      value={
                        emissionData.environment_criteria_list
                          ? emissionData.environment_criteria_list?.map(
                              (criteria, index) => (
                                <li className={classes.list} key={index}>
                                  {index + 1}. {criteria}
                                </li>
                              )
                            )
                          : "NA"
                      }
                      classes={{
                        container: classes.infoContainer,
                        title: classes.supplierScreenTitle,
                        value: classes.value,
                      }}
                    />
                  )}
                <CeroItemPair
                  title="Describe Negative Environmental Impacts:"
                  value={
                    emissionData.negative_env_impact
                      ? emissionData.negative_env_impact
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Actions taken to Address Negative Impacts:"
                  value={
                    emissionData.action_taken_address_env_criteria
                      ? emissionData.action_taken_address_env_criteria
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Number of suppliers screened using Social Criteria:"
                  value={
                    emissionData.suppliers_screened_using_social_criteria
                      ? emissionData.suppliers_screened_using_social_criteria
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Social Criteria:"
                  value={
                    emissionData.social_criteria_list
                      ? emissionData.social_criteria_list?.map(
                          (criteria, index) => (
                            <li className={classes.list} key={index}>
                              {index + 1}. {criteria}
                            </li>
                          )
                        )
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                {emissionData.social_criteria &&
                  emissionData.social_criteria.includes("Others") && (
                    <CeroItemPair
                      title="Social Criteria Details:"
                      value={
                        emissionData.social_criteria_list
                          ? emissionData.social_criteria_list?.map(
                              (criteria, index) => (
                                <li className={classes.list} key={index}>
                                  {index + 1}. {criteria}
                                </li>
                              )
                            )
                          : "NA"
                      }
                      classes={{
                        container: classes.infoContainer,
                        title: classes.supplierScreenTitle,
                        value: classes.value,
                      }}
                    />
                  )}
                <CeroItemPair
                  title="Describe Negative Social Impacts:"
                  value={
                    emissionData.negative_social_impact
                      ? emissionData.negative_social_impact
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Actions taken to Address Negative Impacts:"
                  value={
                    emissionData.action_taken_address_social_criteria
                      ? emissionData.action_taken_address_social_criteria
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Audited on:"
                  value={
                    emissionData.audited_by ? emissionData.audited_by : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
                <CeroItemPair
                  title="Audited by:"
                  value={
                    emissionData.audited_on
                      ? dayjs(emissionData.audited_on).format("DD/MM/YYYY")
                      : "NA"
                  }
                  classes={{
                    container: classes.infoContainer,
                    title: classes.supplierScreenTitle,
                    value: classes.value,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default SupplierScreening;
